var _defs, _rect, _text, _text2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _rect3, _path8, _path9, _path0, _path1, _polygon, _path10, _rect4, _path11, _line, _line2, _line3, _line4, _path12, _path13, _path14, _path15, _rect5, _polygon2, _g, _path16, _path17, _path18, _polygon3, _polygon4, _polygon5, _path19, _path20, _path21, _path22, _g2, _path23, _path24, _path25, _path26, _path27, _path28, _rect6, _path29, _polygon6, _rect7, _rect8, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _polygon7, _path30, _path31, _path32;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalmarketingillustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1600 326.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-12,.cls-13,.cls-16,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-7{fill:none;}.cls-2{fill:#d8c4df;}.cls-3{font-size:75px;}.cls-3,.cls-4,.cls-8{fill:#2f2143;}.cls-3,.cls-4{font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-4{font-size:70px;}.cls-5{fill:#e5ac24;}.cls-6{fill:#2e1f42;}.cls-7{stroke:#4f4e4f;stroke-width:0.39px;}.cls-10,.cls-12,.cls-13,.cls-16,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-7{stroke-miterlimit:10;}.cls-9{fill:#fff;}.cls-10{stroke:#9a499c;}.cls-11{fill:#9a499c;}.cls-12{stroke:#7a797b;stroke-width:0.44px;}.cls-13,.cls-16{stroke:#2f2143;}.cls-13{stroke-width:2px;}.cls-14{opacity:0.5;}.cls-15{clip-path:url(#clip-path);}.cls-17{fill:#cd922a;}.cls-18{fill:#8e8b8c;}.cls-19{clip-path:url(#clip-path-2);}.cls-20{fill:#f7f7f7;}.cls-21,.cls-22,.cls-23{stroke:#e5ac24;}.cls-21{stroke-width:0.66px;}.cls-22{stroke-width:0.62px;}.cls-23{stroke-width:0.6px;}.cls-24,.cls-25{stroke:#fff;stroke-linecap:round;}.cls-25{stroke-dasharray:4.25 4.25;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 199.06,
    y: 24.96,
    width: 60.47,
    height: 23.87
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1231.26,
    y: 37.58,
    width: 43.91,
    height: 39.08,
    transform: "translate(60.74 446.77) rotate(-20.7)"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "digital marketing illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 1600,
    height: 326
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(655.31 179.48)"
  }, "DIGITAL")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(596.66 245.25)"
  }, "MARKETING")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M416.43,236.16l19.19,8a14.84,14.84,0,0,0,19.38-8l.39-.93a14.85,14.85,0,0,0-8-19.39l-19.18-8Z",
    transform: "translate(0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M388.15,207.83c-7.22,17.41-19.13,29-26.6,25.92s-7.68-19.72-.46-37.13,19.12-29,26.6-25.92,7.67,19.73.46,37.13",
    transform: "translate(0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M362.43,234.11l54,2,11.75-28.34-39.62-36.75a57.08,57.08,0,0,1-26.13,63",
    transform: "translate(0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M428.18,207.82s8.07,13.11-11.75,28.34",
    transform: "translate(0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M435.62,244.12s-24.21,25.6-20.94,42.77l-17.57-7.29s18.07-18,21.88-42.38Z",
    transform: "translate(0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M1068.83,88.61A33.6,33.6,0,1,1,1035.23,55a33.6,33.6,0,0,1,33.6,33.59",
    transform: "translate(0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1026.25,121V97.41h-7.32V86.49h7.32V78.14s.06-18.85,25.29-13.4v9.83l-6.89.25s-6.19-.76-5.32,11.67H1051l-2,11-9.83.06v24.54s-7.32.69-12.89-1.07",
    transform: "translate(0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1175.36,
    y: 139.99,
    width: 46.03,
    height: 46.03,
    rx: 8.65
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1183.01,
    y: 147.63,
    width: 30.74,
    height: 30.74,
    rx: 8.65
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M1204,163a5.58,5.58,0,1,1-5.57-5.58A5.57,5.57,0,0,1,1204,163Z",
    transform: "translate(0)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M1209.92,152.77a1.76,1.76,0,1,1-1.76-1.76,1.76,1.76,0,0,1,1.76,1.76",
    transform: "translate(0)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M231.15,177.09H167a3.1,3.1,0,0,1-3.1-3.1V140.85a3.09,3.09,0,0,1,3.1-3.09h64.18a3.09,3.09,0,0,1,3.09,3.09V174a3.09,3.09,0,0,1-3.09,3.1",
    transform: "translate(0)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M229.23,175.36H168.71a3.1,3.1,0,0,1-3.1-3.1V142.58a3.09,3.09,0,0,1,3.1-3.09h60.52a3.09,3.09,0,0,1,3.1,3.09v29.68a3.1,3.1,0,0,1-3.1,3.1",
    transform: "translate(0)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "203.83 157.4 196.21 153 196.21 161.81 203.83 157.4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M205.51,157.42a6.77,6.77,0,1,1-6.76-6.76A6.77,6.77,0,0,1,205.51,157.42Z",
    transform: "translate(0)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 165.61,
    y: 168.92,
    width: 66.72,
    height: 1.51
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1434.23,86.31a5,5,0,1,1-6.72-2.11,5,5,0,0,1,6.72,2.11",
    transform: "translate(0)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 1430.86,
    y1: 83.75,
    x2: 1437.13,
    y2: 57.75
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 1437.61,
    y1: 57.65,
    x2: 1463.51,
    y2: 64.29
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 1474.74,
    y1: 38.06,
    x2: 1468.47,
    y2: 64.06
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-13",
    x1: 1475.42,
    y1: 35.86,
    x2: 1502.04,
    y2: 38.4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1441.69,54.81a5,5,0,1,1-6.72-2.1,5,5,0,0,1,6.72,2.1",
    transform: "translate(0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1471.15,62.81a5,5,0,1,1-6.72-2.1,5,5,0,0,1,6.72,2.1",
    transform: "translate(0)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1479.72,33.36a5,5,0,1,1-6.72-2.11,5,5,0,0,1,6.72,2.11",
    transform: "translate(0)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1508.13,34.55a5,5,0,1,1-6.88,1.47,5,5,0,0,1,6.88-1.47",
    transform: "translate(0)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1155.44,
    y: 254.58,
    width: 61.66,
    height: 38.41
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1155.44 254.58 1186.27 273.78 1217.1 254.58 1155.44 254.58"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M199.86,38.3l17.87,10.31a1.62,1.62,0,0,0,2.43-1.4V26.58a1.62,1.62,0,0,0-2.43-1.4L199.86,35.5a1.62,1.62,0,0,0,0,2.8",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 220.16,
    y: 31.39,
    width: 39.37,
    height: 11.02
  })))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M350.6,176.79s-26.44,7.61-19,35.82",
    transform: "translate(0)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M345.61,162.13s-36.76,10.58-26.38,49.81",
    transform: "translate(0)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M341,148.25s-49,14.08-35.13,66.32",
    transform: "translate(0)"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "560.45 41.17 620.11 64.81 590.8 83.11 560.45 41.17"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "560.45 41.17 605.25 74.24 605.25 86.06 611.05 71.98 560.45 41.17"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "598.58 76.84 605.25 86.06 605.25 74.24 598.58 76.84"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M526.12,178.92H500.25a3.47,3.47,0,0,1-3.47-3.46V119.8a3.47,3.47,0,0,1,3.47-3.46h25.87a3.46,3.46,0,0,1,3.47,3.46v55.66a3.46,3.46,0,0,1-3.47,3.46",
    transform: "translate(0)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M524.55,175.92H501.83a3.47,3.47,0,0,1-3.47-3.47V122.81a3.47,3.47,0,0,1,3.47-3.47h22.72a3.47,3.47,0,0,1,3.47,3.47v49.64a3.47,3.47,0,0,1-3.47,3.47",
    transform: "translate(0)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M515.15,172.82a2,2,0,1,1-2-2,2,2,0,0,1,2,2",
    transform: "translate(0)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M515.48,122.07h-5.74a.72.72,0,0,1,0-1.43h5.74a.72.72,0,0,1,0,1.43",
    transform: "translate(0)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1239.59,83.16a22,22,0,1,1,41.07-15.52",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M1257.35,43.82a8.56,8.56,0,1,1-11-5,8.56,8.56,0,0,1,11,5",
    transform: "translate(0)"
  })))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M74.5,262.09c.33-.82.64-1.66,1-2.48a37,37,0,0,1,7.91-11.82c2.06-2.07,4.1-4.16,6.18-6.22a1.52,1.52,0,0,1,1-.41c3.74,0,7.49,0,11.24-.06a1.38,1.38,0,0,1,1.11.46c2.72,2.79,5.59,5.46,8.14,8.4a34.45,34.45,0,0,1,8.14,17.66,50.78,50.78,0,0,1,.43,5.66,7.67,7.67,0,0,0,3,5.93,7.75,7.75,0,0,1,3,4.25,5.76,5.76,0,0,1,0,3.29,3.7,3.7,0,0,1-3.41,2.57c-2.48,0-5,0-7.43,0H93.91c-8.85,0-15.84,1.49-23,.21-1.57-.29-4.21-.88-5.16-2.91a4.38,4.38,0,0,1,.25-4.06c1.18-1.8,3.08-1,4.31-2.8.83-1.18.29-2,.9-4.56a15.3,15.3,0,0,1,1.51-3.91m23.51-24c0-1.34,0-2.67,0-4a.87.87,0,0,0-.22-.64.87.87,0,0,0-1.36.8c0,2.56,0,5.13,0,7.69,0,.63-.1.95-.82,1.05a8.91,8.91,0,0,0-2.3.67c-4.58,2-7.35,5.47-7.73,10.44a11.9,11.9,0,0,0,6,11.73,12.28,12.28,0,0,0,1.75.89,14,14,0,0,0,5,.93,12.38,12.38,0,0,0,9.12-3.86,13.6,13.6,0,0,0,2.45-11.81,13,13,0,0,0-2.68-5,11.12,11.12,0,0,0-2-1.84A13.06,13.06,0,0,0,96.93,252c-.51-.06-.7-.2-.69-.72,0-1.32,0-2.63,0-4",
    transform: "translate(0)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M97.77,227.18c.5-1,.92-1.86,1.4-2.71a2.12,2.12,0,0,1,.57-.4,7.56,7.56,0,0,1,5.43-.46,5.21,5.21,0,0,1,2.2,1,4,4,0,0,1,.95,1.2,3.26,3.26,0,0,1-.31,3.53c-1.49,2-3.1,3.8-4.53,5.79a2.89,2.89,0,0,1-2.78,1.31c-3.38-.11-6.77-.08-10.16-.13a1.25,1.25,0,0,1-.84-.39c-1.7-2.09-3.4-4.19-5-6.32a3.37,3.37,0,0,1,1.78-5.51,4.56,4.56,0,0,1,.93-.09c2-.11,2.12-.6,3.51-.64a8.72,8.72,0,0,1,3.24.66,2.18,2.18,0,0,1,.92.38c.92.86,1.79,1.78,2.74,2.73",
    transform: "translate(0)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M100.85,240.2H98.64c-.47,0-.79-.18-.78-.7a.69.69,0,0,1,.77-.73c1.47,0,3,0,4.42,0,.5,0,.9.21.89.77s-.42.66-.88.66h-2.21v0",
    transform: "translate(0)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M95.59,269.17c.71,0,1.43,0,2.14,0a1.57,1.57,0,1,0,0-3.13c-1.24,0-2.5,0-3.74-.11a4.4,4.4,0,0,1-4-4.38,4.46,4.46,0,0,1,3.77-4.71c.5-.07.89-.12,1-.78s.73-.84,1.38-.84a1.27,1.27,0,0,1,1.38.94c.13.53.41.59.85.57a5.45,5.45,0,0,1,1.07,0,1.5,1.5,0,0,1-.2,3c-1.49,0-3,0-4.48,0-1.19,0-1.81.66-1.75,1.72a1.3,1.3,0,0,0,1.2,1.37c1.27.11,2.54.08,3.81.14a4.21,4.21,0,0,1,3.28,1.69,4.56,4.56,0,0,1,.63,4.74,4.33,4.33,0,0,1-3.72,2.76c-.35,0-.56.1-.65.5a1.5,1.5,0,0,1-2.87,0,.56.56,0,0,0-.65-.5c-.33,0-.67,0-1,0a1.45,1.45,0,0,1-1.55-1.42A1.48,1.48,0,0,1,93,269.21a1.38,1.38,0,0,1,.2,0h2.41",
    transform: "translate(0)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1535.39,258.67H1349.63a7.29,7.29,0,0,1-7.27-7.26V145.05a7.29,7.29,0,0,1,7.27-7.27h185.76a7.29,7.29,0,0,1,7.26,7.27V251.41a7.29,7.29,0,0,1-7.26,7.26",
    transform: "translate(0)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M1530.91,250H1354.45a6.55,6.55,0,0,1-6.54-6.53V153a6.56,6.56,0,0,1,6.54-6.54h176.46a6.56,6.56,0,0,1,6.54,6.54v90.38a6.55,6.55,0,0,1-6.54,6.53",
    transform: "translate(0)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1347.91,
    y: 154.16,
    width: 189.54,
    height: 6.97
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1490.72,292.57c0,2.94-22.76,5.33-50.84,5.33s-50.85-2.39-50.85-5.33,22.76-5.34,50.85-5.34,50.84,2.39,50.84,5.34",
    transform: "translate(0)"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "1424.23 258.67 1408.11 292.57 1471.64 292.57 1455.99 258.67 1424.23 258.67"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1418.56,
    y: 166.97,
    width: 47.91,
    height: 38.36
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1476.16,
    y: 166.97,
    width: 44.24,
    height: 38.53
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1355.95,
    y1: 169.09,
    x2: 1409.66,
    y2: 169.09
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1355.95,
    y1: 173.58,
    x2: 1409.66,
    y2: 173.58
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1355.95,
    y1: 178.07,
    x2: 1409.66,
    y2: 178.07
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1355.95,
    y1: 182.56,
    x2: 1409.66,
    y2: 182.56
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1355.95,
    y1: 187.05,
    x2: 1409.66,
    y2: 187.05
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1355.95,
    y1: 191.54,
    x2: 1409.66,
    y2: 191.54
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1355.95,
    y1: 196.03,
    x2: 1409.66,
    y2: 196.03
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1355.95,
    y1: 200.52,
    x2: 1409.66,
    y2: 200.52
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1355.95,
    y1: 205.01,
    x2: 1409.66,
    y2: 205.01
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1355.95,
    y1: 209.5,
    x2: 1409.66,
    y2: 209.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1355.95,
    y1: 213.99,
    x2: 1409.66,
    y2: 213.99
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1355.95,
    y1: 218.48,
    x2: 1409.66,
    y2: 218.48
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1355.95,
    y1: 222.97,
    x2: 1409.66,
    y2: 222.97
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1355.95,
    y1: 227.46,
    x2: 1409.66,
    y2: 227.46
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1355.95,
    y1: 231.95,
    x2: 1409.66,
    y2: 231.95
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1355.95,
    y1: 236.44,
    x2: 1409.66,
    y2: 236.44
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 1355.95,
    y1: 240.93,
    x2: 1409.66,
    y2: 240.93
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1418.56,
    y1: 213.99,
    x2: 1466.48,
    y2: 213.99
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1418.56,
    y1: 218.48,
    x2: 1466.48,
    y2: 218.48
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1418.56,
    y1: 222.97,
    x2: 1466.48,
    y2: 222.97
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1418.56,
    y1: 227.46,
    x2: 1466.48,
    y2: 227.46
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1418.56,
    y1: 231.95,
    x2: 1466.48,
    y2: 231.95
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1418.56,
    y1: 236.44,
    x2: 1466.48,
    y2: 236.44
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 1418.56,
    y1: 240.93,
    x2: 1466.48,
    y2: 240.93
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 1476.16,
    y1: 213.99,
    x2: 1521.2,
    y2: 213.99
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 1476.16,
    y1: 218.48,
    x2: 1521.2,
    y2: 218.48
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 1476.16,
    y1: 222.97,
    x2: 1521.2,
    y2: 222.97
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 1476.16,
    y1: 227.46,
    x2: 1521.2,
    y2: 227.46
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 1476.16,
    y1: 231.95,
    x2: 1521.2,
    y2: 231.95
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 1476.16,
    y1: 236.44,
    x2: 1521.2,
    y2: 236.44
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-23",
    x1: 1476.16,
    y1: 240.93,
    x2: 1521.2,
    y2: 240.93
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 42.59,
    y1: 85.53,
    x2: 90.06,
    y2: 64.79
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 58.1,
    y1: 83.44,
    x2: 105.58,
    y2: 62.7
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 57.15,
    y1: 73.98,
    x2: 104.63,
    y2: 53.24
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "376.98 55.05 383.98 51.37 382.64 59.16 388.31 64.68 380.48 65.82 376.98 72.91 373.48 65.82 365.65 64.68 371.31 59.16 369.98 51.37 376.98 55.05"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M20.3,326c.18-.62.41-1.29.67-2",
    transform: "translate(0)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M22.57,320.05c6.9-15.69,25.3-45.2,38.73-55.09,46.77-34.41,103.79,22.26,219.22,41.74,53.21,9,156.75,26.44,217.74-28.31,22.91-20.57,19.32-32.93,62.61-76.69,26.51-26.81,47.28-41.81,53.17-70.43,4-19.19-.43-36.46-4.78-48.07",
    transform: "translate(0)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M608.7,81.15c-.2-.71-.39-1.39-.58-2.05",
    transform: "translate(0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalmarketingillustration);
export default __webpack_public_path__ + "static/media/digital marketing illustration.0a4e0919cb9e7da6e1f01c3aab7c5960.svg";
export { ForwardRef as ReactComponent };